import createReducer from '../../utils/createReducer';
import actionPrefix from '../../utils/actionPrefix';
import { fetchRecommendedProperties } from './recommendedProperties';

const initialState = {};

const prefix = actionPrefix('user');

// Actions
const UPDATE_USER = prefix('UPDATE_USER');

// Reducers
export default createReducer(initialState, {
  [UPDATE_USER](state, { payload }) {
    return {
      ...state,
      ...payload,
      isUserLogged: true
    };
  }
});

// Action creators
export const updateUser = userData => ({
  type: UPDATE_USER,
  payload: userData
});

// Effects
export const fetchUser = ({ publicUuid }) => (dispatch) => {
  if (publicUuid) {
    window.analyticsdatalayer.publicuuid = publicUuid;
    dispatch(updateUser({ publicUuid }));
    dispatch(fetchRecommendedProperties());
  } else {
    window.location.reload();
  }
};
